import { FC } from 'react';
import {
  TablePagination as MuiTablePagination,
  TablePaginationProps as MuiTablePaginationProps,
} from '@mui/material';

type TablePaginationProps = {
  page: number;
  rowsPerPage: number;
  total: number;
  totalPages: number;
  onPageChange: MuiTablePaginationProps['onPageChange'];
  onRowsPerPageChange: MuiTablePaginationProps['onRowsPerPageChange'];
  isLoading: boolean;
};

export const TablePagination: FC<TablePaginationProps> = (props) => {
  const { page, rowsPerPage, total, totalPages, onPageChange, onRowsPerPageChange, isLoading } =
    props;

  return (
    <MuiTablePagination
      page={page}
      rowsPerPage={rowsPerPage}
      count={total}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      component="div"
      rowsPerPageOptions={[10, 20, 50, 100]}
      slotProps={{
        actions: {
          previousButton: { disabled: isLoading || page === 0 },
          nextButton: { disabled: isLoading || page + 1 === totalPages },
        },
      }}
    />
  );
};
